<template lang="pug">
div
  section.u-mt-md
    AppTitle.u-mb-xm(:title="$t('mantra')")
    .grid.is-widescreen-8.is-desktop-10
      .column
        p.u-text-lg {{$t('mantraDesc')}}

  section.u-mt-md
    AppTitle.u-mb-mi(:title="$t('sec1')" tag="h2")
    .grid.is-tablet-6
      .column.u-mb-col(v-for="item,idx in $t('sec1Items')")
        AppCardBox
          AppLink(:to="item.url" :title="item.title"  class="cardBox-url")
          h4 {{item.title}}
          p {{item.desc}}


  section.u-mt-md.u-mb-md
    AppTitle.u-mb-sm(:title="$t('cta')" tag="h2")
    AppLink(to="/contact" :title="$t('ctaBtn')" class="button-link is-large " v-html="$t('ctaBtn')")

</template>

<script>
export default {
  head() {
    const $t = this.$t.bind(this);
    return {
      title: $t('pageTitle'),
      meta: [
        {
          hid: 'og:title',
          name: 'og:title',
          property: 'og:title',
          content: $t('pageTitle')
        },
        {
          hid: 'description',
          name: 'description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:description',
          name: 'og:description',
          property: 'og:description',
          content: $t('pageDesc')
        }
      ]
    };
  }
};
</script>

<i18n>
{
  "en": {
    "pageTitle":"Infringement",
    "pageDesc":"Send us your concerns regarding trademark violations or copyright infringements.",
    "mantra":"Report your |violation concerns.",
    "mantraDesc":"In Baianat, we are committed to supporting the protection of intellectual property and will be always helping copyrights and trademarks owners to get their legal rights.",
    "sec1":"Kindly pick your |violation concern",
    "sec1Items":{
      "1":{
        "title":"Trademark",
        "desc":"Report complaints of a registered trademark.",
        "url":"/report"
      },
      "2":{
        "title":"Copyrights",
        "desc":"Reporting complaints of copyrighted work.",
        "url":"/report"
      }
    },
    "cta":"Need further |instructions ?",
    "ctaBtn":"Contact us"
  },
  "ar": {
    "pageTitle":"الانتهاكات",
    "pageDesc":"أرسل لنا مخاوفك بشأن انتهاكات العلامات التجارية أو انتهاكات حقوق الطبع والنشر أو الملكية الفكرية.",
    "mantra":"أبلغ عن مخاوفك| بشأن الانتهاك. ",
    "mantraDesc":"في بيانات، نلتزم بدعم حماية الملكية الفكرية وسنساعد دائمًا مالكي حقوق الطبع والنشر والعلامات التجارية في الحصول على حقوقهم القانونية.",
    "sec1":"برجاء اختيار نوع الانتهاك |الذي يسبب لك الضرر",
    "sec1Items":{
      "1":{
        "title":"العلامة التجارية",
        "desc":"أبلغ عن الشكوى حول العلامة التجارية المسجلة.",
        "url":"/report"
      },
      "2":{
        "title":"حقوق التأليف والنشر",
        "desc":"أبلغ عن شكاوى العمل المحمي بحقوق الطبع والنشر.",
        "url":"/report"
      }
    },
    "cta":"تحتاج إلى المزيد| من التعليمات؟",
    "ctaBtn":"اتصل بنا"
  }
}
</i18n>
